import type { OrderLineItem, ReturnRequest } from "../types";

// `quantity_bought` already carries Shopify's own returnable bookkeeping: a
// return request is pushed to Shopify as soon as it is created (it then holds a
// `shopifyReturnId`), and Shopify drops those units from the returnable
// quantity right away. Subtracting them here as well double-counts them and
// hides units the customer can still return.
//
// Return requests that never reached Shopify (non-Shopify providers, or a
// failed `returnCreate`) are absent from that bookkeeping, so they are the only
// ones we subtract ourselves.
export function getReturnableQuantity(
  lineItem: OrderLineItem,
  returnRequests: ReturnRequest[],
): number {
  const claimed = sumUnsyncedReturnedQuantity(
    returnRequests,
    lineItem.line_item_id,
  );

  return Math.max(0, (lineItem.quantity_bought ?? 0) - claimed);
}

export function filterReturnableItems(
  lineItems: OrderLineItem[],
  returnRequests: ReturnRequest[],
): OrderLineItem[] {
  return lineItems.filter(
    (lineItem) => getReturnableQuantity(lineItem, returnRequests) > 0,
  );
}

function sumUnsyncedReturnedQuantity(
  returnRequests: ReturnRequest[],
  lineItemId: string,
): number {
  return returnRequests
    .filter((rr) => !rr.status.cancelled.done && !rr.shopifyReturnId)
    .flatMap((rr) => rr.line_items)
    .filter((li) => li.line_item_id === lineItemId)
    .reduce((total, li) => total + Math.max(0, li.quantity ?? 0), 0);
}
